import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import useDecodedToken from "../../features/utils/hooks/useDecodedToken";
import { Button, Pagination, OverlayTrigger, Tooltip } from "react-bootstrap";
import AssigntoDm from "./AssigntoDm";
import { formatDate } from "../../utils/dateUtils";
import { formatAmount } from "../../utils/amountFormat";
import Breadcrumbs from "./../../Breadcrumbs";

import { format } from "date-fns";
import Select from "react-select";
import { Link, useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import VewRequest from "../dmRequest/VewRequest";
import ViewSubRequest from "../dmRequest/ViewSubRequest";
import { fetchInfReqData } from "../../features/clientRequstSlice/suggestedInfRequestSlice";

export const headerData = {
  sr_no: "SR No.",
  action: "Action",
  sub_req_count: "Sub Request Count",
  sub_req: "Sub Request",
  inHouseStatus: "Inhouse Status",
  status: "status",
  request_id: "Request ID",
  pro_name: "Product Name",
  no_influencer: "Required Influencer",
  budget: "Client Budget",
  category: "Categories",
  requestedDate: "Requested Date",
};

const SuggestedInfluencerDetails = () => {
  const navigate = useNavigate();
  const decodedToken = useDecodedToken();
  const dispatch = useDispatch();
  const location = useLocation();
  const selectedInfReqData = location.state;
  const [clientsData, setClientsData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [clientsPerPage, setClientsPerPage] = useState(10);
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [subRequestModal, setSubRequestModal] = useState(false);

  const [showAssignSaleModal, setAssignSaleModel] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const { infReqData, status, error } = useSelector(
    (state) => state.influencerSug,
  );

  useEffect(() => {
    dispatch(
      fetchInfReqData({
        inf_req_id: selectedInfReqData?.id,
        page: currentPage,
        limit: clientsPerPage === "All" ? "All" : clientsPerPage,
      }),
    );
  }, [dispatch, currentPage, clientsPerPage]);

  useEffect(() => {
    if (status === "succeeded") {
      setClientsData(infReqData?.data || []);
    }
  }, [status, infReqData]);

  // Sorting logic
  const sortTable = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const handleSuugestedInfluencerDetails = (rowData) => {
    setAssignSaleModel(true);
    setSelectedData(rowData);
    navigate(`/surggested-influencer-details-by-id/${rowData?.id}`, {
      state: rowData,
    });
  };

  const handleDetailClient = (rowData) => {
    setShowDetailModal(true);
    setSelectedData(rowData);
  };

  const handleSubRequestClient = (rowData) => {
    setSubRequestModal(true);
    setSelectedData(rowData);
  };

  const handleClientsPerPageChange = (selectedOption) => {
    setClientsPerPage(selectedOption.value);
    setCurrentPage(1); // Reset to first page whenever per page value changes
  };
  const perPageOptions = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: "All", label: "All" }, // Add 'All' option
  ];

  const totalItems = clientsData.length;

  const totalPages =
    clientsPerPage === "All" ? 1 : Math.ceil(totalItems / clientsPerPage);

  const sortedData = [...clientsData].sort((a, b) => {
    if (!sortConfig.key) return 0;

    const aValue = a[sortConfig.key];
    const bValue = b[sortConfig.key];

    if (sortConfig.direction === "ascending") {
      return String(aValue).localeCompare(String(bValue));
    }

    return String(bValue).localeCompare(String(aValue));
  });

  const paginatedData =
    clientsPerPage === "All"
      ? sortedData
      : sortedData.slice(
          (currentPage - 1) * clientsPerPage,
          currentPage * clientsPerPage,
        );

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0">All Suggested influencer  </h4>

            <div className="page-title-right">
              <Breadcrumbs />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="card" id="leadsList">
            <div className="card-header border-0">
              <div className="row g-4 align-items-center">
                <div className="col-sm-1">
                  <label className="small">Select Records</label>
                  <Select
                    className="basic-single small"
                    classNamePrefix="select"
                    name="perPage"
                    options={perPageOptions}
                    defaultValue={perPageOptions[0]}
                    onChange={handleClientsPerPageChange}
                  />
                </div>
                <div className="col-sm-auto ms-auto">
                  <div className="hstack gap-2">
                    {/* <button type="button" className="btn btn-sm btn-info" data-bs-toggle="offcanvas" href="#offcanvasExample">
                                            <i className="ri-filter-3-line align-bottom me-1"></i> Filters
                                        </button> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body">
              <table
                id="example"
                className="table table-bordered nowrap table-striped align-middle"
                style={{ width: "100%" }}
              >
                <thead>
                  <tr>
                    <th>SR No.</th>                    
                    <th>Suggested By</th>
                    <th>Suggested Cost</th>
                    <th>Final Cost</th>
                    <th>Status</th>
                    <th>Created Date</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedData.length > 0 ? (
                    paginatedData.map((item, index) => {
                      return (
                        <tr key={item.id}>
                          <td>
                            {(currentPage - 1) *
                              (clientsPerPage === "All"
                                ? totalItems
                                : clientsPerPage) +
                              index +
                              1}
                          </td>

                          <td>{item.suggested_by_name}</td>

                          <td>₹ {formatAmount(item.suggested_cost)}</td>

                          <td>₹ {formatAmount(item.final_cost)}</td>

                          <td>
                            <span
                              className={`badge ${
                                item.status === 1 ? "bg-success" : "bg-danger"
                              }`}
                            >
                              {item.status === 1 ? "Active" : "Inactive"}
                            </span>
                          </td>

                          <td>{formatDate(item.created_by)}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="12" className="text-center">
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <div className="row">
                {clientsPerPage !== "2000" && (
                  <>
                    <div className="col-sm-6">
                      {totalItems > 0 ? (
                        <>
                          Showing {(currentPage - 1) * clientsPerPage + 1} to{" "}
                          {Math.min(currentPage * clientsPerPage, totalItems)}{" "}
                          of {totalItems} entries
                        </>
                      ) : (
                        <>Showing 0 to 0 of 0 entries</>
                      )}
                    </div>
                    <div className="col-sm-6">
                      {totalPages > 0 && (
                        <Pagination className="justify-content-end">
                          <Pagination.Prev
                            onClick={() =>
                              setCurrentPage(
                                currentPage > 1 ? currentPage - 1 : currentPage,
                              )
                            }
                            disabled={currentPage === 1}
                          />

                          {Array.from({ length: totalPages }, (_, index) => (
                            <Pagination.Item
                              key={index + 1}
                              active={index + 1 === currentPage}
                              onClick={() => setCurrentPage(index + 1)}
                            >
                              {index + 1}
                            </Pagination.Item>
                          ))}

                          <Pagination.Next
                            onClick={() =>
                              setCurrentPage(
                                currentPage < totalPages
                                  ? currentPage + 1
                                  : currentPage,
                              )
                            }
                            disabled={currentPage === totalPages}
                          />
                        </Pagination>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {showDetailModal && (
        <VewRequest
          showModal={showDetailModal}
          setShowModal={setShowDetailModal}
          selectedData={selectedData}
        />
      )}
      {/* {showAssignSaleModal && (
        <AssigntoDm
          showModal={showAssignSaleModal}
          setShowModal={setAssignSaleModel}
          selectedData={selectedData}
        />
      )} */}
      {subRequestModal && (
        <ViewSubRequest
          showModal={subRequestModal}
          setShowModal={setSubRequestModal}
          selectedData={selectedData}
        />
      )}
    </>
  );
};

export default SuggestedInfluencerDetails;
